import {$dom} from '../helpers/dom';
import homePage from './pages/home';
import catalogPage from './pages/catalog';
import articlePage from './pages/article';
import projectPage from './pages/project';
import servicePage from './pages/service';
import aboutPage from './pages/about';
import contactsPage from './pages/contacts';
import statisticsPage from './pages/statistics';
import regularPage from './pages/regular';
import {$events} from '../helpers/events';
import newsSinglePage from './pages/news-single';


$dom.ready(() => {
	window.currentPage = [
		homePage,
		catalogPage,
		articlePage,
		projectPage,
		servicePage,
		aboutPage,
		contactsPage,
		statisticsPage,
		regularPage,
		newsSinglePage
	].filter(page => page.exist)[0];

	currentPage && currentPage.init();

	$events.delegate.on('click tap', '.js-modal-run', function () {
		eval($dom.get('code', this.closest('.js-modal-example')).innerText)
	});

});
